import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LabelWrapper from "../../../components/DividerWithLabel/LabelWrapper.tsx";
import { formatPrice } from "../../../helpers/formatPrice";
import { useAppSelector } from "../../../services/hooks.ts";
import SiteSummaryDelivery from "./SiteSummary/SiteSummaryDelivery.tsx";
import SiteSummaryProducts from "./SiteSummary/SiteSummaryProducts.tsx";
import { ChildrenPropsTypes } from "../../../helpers/childrenProps.types.ts";
import childrenFilter from "../../../helpers/childrenFilter.tsx";
import { motion } from "motion/react";
import AnimateNumber from "../Motion/AnimateNumber.tsx";
import { DeliveryType } from "../../../stores/cart/cartSlice.types.ts";
import { roundToTwo } from "../../../helpers/roundToTwo.tsx";
import { useTranslation } from "react-i18next";

function SiteSummary({ children }: ChildrenPropsTypes) {
    const cartVat = useAppSelector((state) => state.cart.vat);
    const cartNetValue = useAppSelector((state) => state.cart.value);
    const cartGrossValue = useAppSelector((state) => state.cart.valueGross);
    const currency = useAppSelector((state) => state.user.currency);
    const activeDelivery = useAppSelector((state) => state.cart.activeDeliveryOption);
    const deliveryMethods = useAppSelector((state) => state.cart.deliveryOptions);
    const { t } = useTranslation('cart');

    const cartFinalValue = {
        gross: cartGrossValue + (getDeliveryPrice('packages').priceGross || 0) + (getDeliveryPrice('pallets').priceGross || 0),
        net: cartNetValue + (getDeliveryPrice('packages').priceNet || 0) + (getDeliveryPrice('pallets').priceNet || 0),
    };

    function getDeliveryPrice(type: DeliveryType) {
        const delivery = activeDelivery[type];

        if (deliveryMethods.loading) return 0;
        if (delivery === null) return 0;
        if (typeof deliveryMethods[type] === 'undefined' || !Array.isArray(deliveryMethods[type])) return 0;
        if (typeof deliveryMethods[type][delivery] !== 'object') return 0;

        return deliveryMethods[type][delivery];
    }

    //= activeDelivery !== null ? (cartGrossValue + /*deliveryOptions[activeDelivery]["priceGross"]*/0) : cartGrossValue

    /*const disabled =
        path === '/cart' || path === '/cart/'
            ? loadingQuantity
            : path.includes('/checkout')
                ? orderingDisabled
                : false*/

    //let endLinkFinal
    /*if (path.includes('/summary/')) {
        const { handleEnd, endLink } = useCart()
        handleEndFinal = handleEnd
        endLinkFinal = endLink
    } else {
        const { handleEnd, endLink } = useCart()
        handleEndFinal = handleEnd
        endLinkFinal = endLink
    }*/

    /* const deliveryPrice = cartDataFinal.activeDeliveryMethod !== null ? cartDataFinal.deliveryMethods[cartDataFinal.activeDeliveryMethod]['price'] : 0
    const cartFinalPrice = cartGrossValue + delivery?.priceGross ?? 0; */


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="sticky-top" style={{ "top": "80px", "zIndex": 0 }}
        >
            <LabelWrapper label={t('summary.header')}>
                <Container className="py-3">
                    {childrenFilter(children, SiteSummary.Top)}

                    <SiteSummaryProducts />

                    <Row>
                        <Col className="text-end">
                            <SiteSummaryDelivery />
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <hr />
                </Container>
                <Container className="py-2">
                    <Row>
                        <Col>
                            <strong>{t('summary.vat_rate')}:</strong>
                        </Col>
                        <Col className="text-end">
                            {cartVat * 100}%
                            <VATViesAvailable />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={5}>
                            <strong>{t('summary.total')}:</strong>
                        </Col>
                        <Col className="text-end fs-5">
                            <AnimateNumber KEY={cartFinalValue.net}>
                                {formatPrice(roundToTwo(cartFinalValue.gross / 100), currency)} {t('summary.total_gross')}<br />
                                <small>{formatPrice(roundToTwo(cartFinalValue.net / 100), currency)} {t('summary.total_net')}</small>
                            </AnimateNumber>
                        </Col>
                    </Row>

                    {childrenFilter(children, SiteSummary.Button)}
                </Container>

                {childrenFilter(children, SiteSummary.Footer)}
            </LabelWrapper>
        </motion.div>
    )
}

SiteSummary.Top = ({ children }: ChildrenPropsTypes) => {
    return (
        <Row className="text-center text-xl-start">
            {children}
        </Row>
    )
};

SiteSummary.Footer = ({ children }: ChildrenPropsTypes) => children;

SiteSummary.Button = ({
    children,
    disabled = false,
    className = '',
    onClick = () => null
}: ChildrenPropsTypes & { disabled?: boolean, className?: string, onClick?: () => void }) => {
    return (
        <Row className={"pt-3 " + className}>
            <div className="d-grid">
                <Button
                    disabled={disabled}
                    className="py-4"
                    variant="success"
                    role={'button'}
                    name={'next-step-button'}
                    onClick={onClick}
                >
                    {children}
                </Button>
            </div>
        </Row>
    )
};

const VATViesAvailable = () => {
    const cartVatAvailable = useAppSelector((state) => state.cart.vatAvailable);
    const { t } = useTranslation('cart');

    if (cartVatAvailable === null) return '';

    return (<>
        <br />
        {
            cartVatAvailable === 0 && <small className={'text-danger'}>{t('summary.vies.offline')}</small>
        }
        {
            cartVatAvailable === 1 && <small className={'text-danger'}>{t('summary.vies.n_ok')}</small>
        }
        {
            cartVatAvailable === 2 && <small className={'text-success'}>{t('summary.vies.ok')}</small>
        }
    </>);
}


export default SiteSummary;